<!-- Sidebar banner -->
<div class="sidebar-main-container">

    <div class="sidebar-right-cover" (click)="onCloseBannerHandler()"></div>

    <section class="sidebar-section animate__animated" [class]="!isClosingBanner ? 'animate__fadeInRightBig' : 'animate__fadeOutRight'">

        <div class="w-[450px] max-w-[450px] relative">

            <shared-loader [message]="loaderMessage" [is-loading]="isLoadingBanner" *ngIf="isLoadingBanner" zIndex="z-30"></shared-loader>

            <div class="h-full flex flex-col bg-white shadow-xl pb-4 pt-12 px-4 scroll relative">

                <!-- Sidebar Header -->
                <div class="sidebar-right-header">
                    <h2>CONFIGURACIÓN DEL SISTEMA</h2>
                </div>

                <form class="flex justify-between flex-col h-full overflow-auto scroll" [formGroup]="form">

                    <!-- Sidebar Content -->
                    <div class="sidebar-right-content">

                        <div class="mb-10">
                            <h3 class="text-xl font-semibold text-black border-b border-gray-300 pb-4">
                                AYUDA PARA EL USUARIO
                            </h3>
                            <div class="mt-8">
                                <div class="control-box">
                                    <label for="file">Manual de uso:</label>
                                    <div class="control-container">
                                        <input class="control file" type="file" name="file" accept=".pdf" (change)="onChangeFile($event)" name="fileName" />
                                    </div>
                                    <span *ngIf="isValidControl('fileName')" class="control-label-error">
                                        El archivo no debe ser mayor de 10MB y tiene que estar en formato PDF.
                                    </span>
                                </div>
                            </div>

                            <h3 class="text-xl font-semibold text-black border-b border-gray-300 pb-4">
                                AVISO DE CONFIDENCIALIDAD
                            </h3>
                            <div class="mt-8">
                                <div class="control-box">
                                    <label for="noticeConfidentiality">Aviso de confidencialidad: <span class="text-red-600">*</span></label>
                                    <div class="control-container">
                                        <textarea class="control scroll" name="noticeConfidentiality" placeholder="Aviso de confidencialidad" formControlName="noticeConfidentiality"></textarea>
                                    </div>
                                    <span *ngIf="isValidControl('noticeConfidentiality')" class="control-label-error">El aviso de confidencialidad es requerido y debe tener menos de 500 caracteres</span>
                                </div>

                                <div class="control-box">
                                    <label for="resetNoticeConfidentiality">¿Solicitar nuevamente confidencialidad?</label>
                                    <div class="control-container mb-4">
                                        <label class="toggle-container">
                                            <input class="checkbox-toggle peer" type="checkbox" name="resetNoticeConfidentiality" formControlName="resetNoticeConfidentiality">
                                            <span class="toggle primary"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Sidebar Footer -->
                    <div class="flex justify-center items-center gap-x-5 px-4 mb-8">
                        <button class="button red mt-3 w-full" (click)="onCloseBannerHandler()">
                            Cancelar
                        </button>
                        <button class="button green mt-3 w-full" (click)="save()">
                            Guardar
                        </button>
                    </div>

                </form>
            </div>
        </div>
    </section>
</div>